import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {HelperDeposit} from "app/archivage/common/helper/helperDeposit";
import {Deposit, DepositLocation, DepositState} from "app/archivage/common/services/deposit/deposit.model";
import {DepositService} from "app/archivage/common/services/deposit/deposit.service";
import {finalize} from "rxjs/operators";
import {PubSubService} from "@Common/core/services";
import {SubSink} from "@Common/core/utils/subsink";
import {HelperIndividuService} from "app/archivage/common/services/helper-individu/helper-individu.service";
import {MatDialog} from "@angular/material/dialog";
import {DialogIncompleteComponent} from "app/archivage/deposit/modal/incomplete/incomplete.component";
import {DialogDoneComponent} from "app/archivage/deposit/modal/dialog-done/dialog-done.component";
import {formatDate} from "@angular/common";
import {DialogArchivedComponent} from "app/archivage/deposit/modal/dialog-archived/dialog-archived.component";
import {LocationService} from "app/archivage/common/services/deposit/location.service";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MatSelectChange} from '@angular/material/select';

@Component({
  selector: 'app-take-charge',
  templateUrl: './take-charge.component.html',
  styleUrls: ['./take-charge.component.scss'],
})
export class TakeChargeComponent implements OnInit, OnDestroy {
  @Input() deposit: Deposit;
  @Input() editMode = false;
  conservations: { id, label }[];
  subSink = new SubSink();
  depositState = DepositState;
  depositForm: UntypedFormGroup;
  locked = false;

  constructor(
    public dialog: MatDialog,
    public depositSvc: DepositService,
    private locationSvc: LocationService,
    private pubSubSvc: PubSubService,
    public helperDeposit: HelperDeposit,
    private helperIndividuService: HelperIndividuService,
    private formBuilder: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    this.conservations = this.depositSvc.selectConservation();
    this.depositForm = this.formBuilder.group({
      conservation: [this.deposit.conservation || null, Validators.required],
    });
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

  ngAfterViewInit() {
    this.locked = this.isValidatedState() || this.isArchivedState();
  }

  getClassColor(status) {
    return this.helperDeposit.getClassColor(status);
  }
  isIncompleteState() { // INCOMPLETE
    return this.helperDeposit.isIncompleteState(this.deposit?.state);
  }
  isWaitingState() { // WAITING
    return this.helperDeposit.isWaittingState(this.deposit?.state);
  }
  isValidatedState() { // DONE
    return this.helperDeposit.isValidatedState(this.deposit?.state);
  }
  isArchivedState() {
    return this.helperDeposit.isArchivedState(this.deposit?.state);
  }

  saveDepositIncomplete() {
    const dialogRef = this.dialog.open(DialogIncompleteComponent, {
      width: '550px',
      data: {},
      disableClose: true
    });
    this.subSink.sink = dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.deposit.state = this.depositState.INCOMPLETE;
          this.deposit.motif = result.message;
          this._patchDeposit();
        }
      }
    );
  }

  saveDepositDone() {
    const dialogRef = this.dialog.open(DialogDoneComponent, {
      width: '550px',
      data: {},
      disableClose: true
    });
    this.subSink.sink = dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          // La chaine retournée par datepicker est de la forme:
          // Wed Aug 24 2022 00:00:00 GMT+0200 (heure d’été d’Europe centrale)
          // Django stocke la date au format YYYY-MM-DD
          this.deposit.state = this.depositState.DONE;
          this.deposit.motif = '';
          this.deposit.incoming_date = formatDate(`${result.incomingDate}`, 'yyyy-MM-dd', 'en-GB');
          this._patchDeposit();
        }
      }
    );
  }

  displayIncDate() {
    // Django stocke la date au format YYYY-MM-DD
    const incDate = this.deposit?.incoming_date;
    if (incDate) return incDate.split('-').reverse().join('/');
    return '';
  }

  saveDepositArchived() {
    const dialogRef = this.dialog.open(DialogArchivedComponent, {
      width: '550px',
      data: {},
      disableClose: true
    });
    this.subSink.sink = dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this._createLocation(result);
        }
      }
    );
  }

  displayLocation() {
    return this.locationSvc.displayLocation(this.deposit?.location_obj);
  }

  private _createLocation(data) {
    const loc: DepositLocation = {
      magasin: data.mag.id,
      epi: data.epi,
      tra: data.tra,
      ray: data.ray,
      tab: data.tab,
    };
    this.pubSubSvc.publish('loading', true);
    this.locationSvc.create(loc)
      .pipe(
        finalize(() => this.pubSubSvc.publish('loading', false))
      )
      .subscribe(
      (result) => {
        if (result) {
          this.deposit.state = this.depositState.ARCHIVED;
          this.deposit.motif = '';
          this.deposit.location = result.id;
          this._patchDeposit();
        }
      });
  }

  private _patchDeposit() {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.depositSvc.patch(this.deposit)
      .pipe(
        finalize(() => this.pubSubSvc.publish('loading', false))
      )
      .subscribe(
      (result) => this.deposit = result
      );
  }

  setConservation(event: MatSelectChange): void {
    this.deposit.conservation = event.value;
    this.subSink.sink = this.depositSvc.patch(this.deposit)
      .subscribe(
        (result) => {
          this.deposit = result;
          this.locked = true;
        }
      );
  }

  setPadlock(): void{
    this.locked = !this.locked;
  }
}
